<template>
    <b-button
        v-if="authorized && visible"
        :block="block"
        :disabled="disabled"
        :class="{'placeholder-label': label === false }"
        :id="id"
        :pill="pill"
        :size="size"
        :target="target"
        :title="title"
        :variant="(outline ? 'outline-' : '') + color"
        @click="$emit('click', $event)"
        v-rkm-tooltip.hover
    >
        <slot />
    </b-button>
</template>

<script>
import { permissao } from '@/mixins'
import { BButton } from 'bootstrap-vue'

export default {
    components: { BButton },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
    },
    created() {
        this.authorized = this.verificarPermissao(this.authorize)
    },
    data: () => ({
        authorized: true
    }),
    mixins: [ permissao ],
    props: {
        authorize: { type: String, default: '' },
        block: { type: Boolean, default: false },
        label: { type: [String, Boolean], default: '' },
        color: { type: String, default: 'secondary' },
        disabled: { type: Boolean, default: false },
        id: { type: String },
        large: { type: Boolean, default: false },
        outline: { type: Boolean, default: false },
        pill: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        target: { type: String, default: '_self' },
        title: { type: String, default: '' },
        visible: { type: Boolean, default: true },
    }
}
</script>